import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { CreditType } from '../../interfaces/credit';
import type { Profile } from '../../interfaces/profile';
import type { RootState } from '../reducers';

export interface CourseCertificateDetails {
  firstName: string;
  lastName: string;
  courseTitle: string;
  courseSubtitle: string;
  courseCompletionDate: string;
  cmePoints: number;
  courseType: CreditType.CCCR | CreditType.E2I;
  clinicalRole: Profile['clinicalRole'];
}

type CourseCertificateState = {
  data: CourseCertificateDetails | null;
  loading: boolean;
  error: string | null;
};

const initialState: CourseCertificateState = {
  data: null,
  loading: false,
  error: null,
};

export const courseCertificateSlice = createSlice({
  name: 'courseCertificate',
  initialState,
  reducers: {
    setCourseCertificateLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setCourseCertificateData: (
      state,
      action: PayloadAction<CourseCertificateDetails>,
    ) => {
      state.data = action.payload;
      state.error = null;
    },
    setCourseCertificateError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
    },
    resetCourseCertificate: () => initialState,
  },
});

export const {
  setCourseCertificateLoading,
  setCourseCertificateData,
  setCourseCertificateError,
  resetCourseCertificate,
} = courseCertificateSlice.actions;

export const courseCertificateDataSelector = (state: RootState) =>
  state.courseCertificate.data;
export const courseCertificateLoadingSelector = (state: RootState) =>
  state.courseCertificate.loading;

export default courseCertificateSlice.reducer;
